(function(){
  if(window.__xstrapFAQLoaded)return;
  window.__xstrapFAQLoaded=true;
  function activate(root,key,focus){
    if(!root)return;
    var tabs=root.querySelectorAll('[data-xfaq-tab]'),panels=root.querySelectorAll('[data-xfaq-panel]');
    tabs.forEach(function(t){var active=t.dataset.xfaqTab===key;t.setAttribute('aria-selected',active?'true':'false');t.setAttribute('tabindex',active?'0':'-1');t.classList.toggle('xfaq__tab--active',active);if(active&&focus)t.focus()});
    panels.forEach(function(p){p.hidden=p.dataset.xfaqPanel!==key});
  }
  document.addEventListener('click',function(e){
    var tab=e.target.closest('[data-xfaq-tab]');if(!tab)return;
    activate(tab.closest('[data-xfaq-section]'),tab.dataset.xfaqTab,false);
  });
  document.addEventListener('keydown',function(e){
    var tab=e.target.closest('[data-xfaq-tab]');if(!tab)return;
    if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft'&&e.key!=='Home'&&e.key!=='End')return;
    var root=tab.closest('[data-xfaq-section]'),tabs=Array.from(root.querySelectorAll('[data-xfaq-tab]'));
    var i=tabs.indexOf(tab);if(i<0)return;e.preventDefault();
    var next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
    activate(root,tabs[next].dataset.xfaqTab,true);
  });
  document.addEventListener('shopify:block:select',function(e){
    var block=e.target.closest('[data-xfaq-block]');if(!block)return;
    var root=block.closest('[data-xfaq-section]');
    activate(root,block.dataset.xfaqCategory,false);
    block.open=true;
    block.scrollIntoView({block:'nearest',behavior:'smooth'});
  });
})();